export type Plan =
  | "FREE"
  | "PREMIUM"
  | "PREMIUM_PLUS";

export type UiStyle =
  | "SPATIAL_FLOW"
  | "SOFT_NEUMORPHISM"
  | "LIQUID_GLASS";

export type LiquidPalette =
  | "AURORA"
  | "CYAN_LAGOON"
  | "COFFEE_MILK";

const planRank: Record<Plan, number> = {
  FREE: 0,
  PREMIUM: 1,
  PREMIUM_PLUS: 2,
};

const styleMinimumPlan: Record<UiStyle, Plan> = {
  SPATIAL_FLOW: "FREE",
  SOFT_NEUMORPHISM: "PREMIUM",
  LIQUID_GLASS: "PREMIUM_PLUS",
};

export function isStyleAvailable(
  style: UiStyle,
  plan: Plan,
): boolean {
  return (
    planRank[plan] >=
    planRank[styleMinimumPlan[style]]
  );
}

export function defaultStyle(): UiStyle {
  return "SPATIAL_FLOW";
}